import { SxProps } from "@mui/material";

export const sxCalendar: SxProps = {
    width: '100%',
    ".MuiDateCalendar-root": {
        backgroundColor: '#00995D',
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08);'
    },
    ".MuiPickersCalendarHeader-root": {
        backgroundColor: '#00995D',
        color: '#fff',
        textTransform: 'uppercase',
        borderRadius: '10px 10px 0px 0px',
        paddingTop: '15px',
        paddingBottom: '15px',
        margin: '0',
        maxHeight: 'none',
    },
    ".MuiPickersCalendarHeader-labelContainer": {
        fontFamily: 'Unimed-Sans',
        fontWeight: '700',

    },
    ".MuiDayCalendar-root": {
        backgroundColor: "#fff"
    },
    ".MuiPickersCalendarHeader-switchViewButton": {
        color: '#fff'
    },
    ".MuiPickersArrowSwitcher-button": {
        color: '#fff'
    },
    ".MuiDayCalendar-weekDayLabel": {
        fontFamily: 'Unimed-Sans',
        fontWeight: '700',
        color: '#4C4C4C'
    },
    ".MuiPickersDay-root": {
        fontFamily: 'Unimed-Sans',
        color: '#175736',
        backgroundColor: '#90CAA6'
    },
    "MuiPickersDay-root:focus": {
        backgroundColor: '#00995D'
    },
    "MuiPickersDay-root:hover": {
        backgroundColor: '#00995D'
    },
    ".MuiPickersYear-yearButton": {
        fontFamily: 'Unimed-Sans',
        color: '#4C4C4C'
    },
    ".Mui-selected": {
        backgroundColor: '#00995D',
        color: "#fff"
    },
    ".Mui-selected:focus": {
        backgroundColor: '#00995D'
    },
    ".Mui-selected:hover": {
        backgroundColor: '#156D44'
    },
    ".Mui-disabled": {
        background: 'none'
    },
    '.MuiButton:hover .MuiButton-contained': {
        backgroundColor: '#00995D',
    }
}
